import React, { useReducer, useEffect, useContext } from "react";

import atributosFichaTecContext from "./atributosFichaTecContex";
import { ACTUALIZAR_LIST_ATRIBUTOS_FICHA } from "./atributosFichaTecActions";
import atributosFichaTecReducer from "./atributosFichaTecReducer";

import {getAllAtributosFichaTecnica,addAtributosFichaTec,updateAtributosFichaTec,deleteAtributosFichaTec, updateAtributoFichaTecnica, deleteAtributoFichaTecnica, addAtributoFichaTecnica} from "../../api/atributosFichaTec";

import authContext from '../authentication/authContex'
import { icon } from "@fortawesome/fontawesome-svg-core";
import Swal from "sweetalert2";

const AtributosFichaTecState = props =>{
     
    const initialState = {
        atributosList: null
    };

    const [state, dispatch] = useReducer(atributosFichaTecReducer, initialState);
    const {usuario} = useContext(authContext);

    const actualizarAtributosFichaTecList = async () => {
        try{
            const resp = await getAllAtributosFichaTecnica();
            const documento = resp.data.data;
            dispatch({
                type: ACTUALIZAR_LIST_ATRIBUTOS_FICHA,
                payload: documento
            });
            
            return documento;
        }catch(err){
            console.log(err)
        }

    };

    const agregarAtributoFichaTec = async (documento) => {
        try{
            let res = await addAtributoFichaTecnica(documento)
            if(res.data.atrCreated != undefined){
                actualizarAtributosFichaTecList();
                return res.data.atrCreated;
            }
        }catch(err){
            console.log(err);
            return err.response.data;
        }
    };
    
    //-------------- Modificar AtributosFichaTecs --------------------------------------------------------------------
    const modificarAtributoFichaTec = async (doc) => {
        try {
            const res = await updateAtributoFichaTecnica(doc);
            if(res.data.docUpdated != undefined){
                actualizarAtributosFichaTecList();
                return res.data.docUpdated;
            }
        } catch (err) {
            return err;
        }
    }
    
    //------------------------------------------------------------------------------------------------

    const eliminarAtributoFichaTec = async (idDoc) => {
        
        try{
            //Solo requiere el id del documento a eliminar.
            const res = await deleteAtributoFichaTecnica(idDoc);
            console.log(res);
            
            if(res.data.deleted){
                actualizarAtributosFichaTecList();
                return res.data.deleted;
            }else if(res.data.msgError){
                Swal.fire({
                    title:'Imposible eliminar atributo!',
                    text:res.data.msgError,
                    icon:'error'
                })
                return false;
            }
        }catch(err){
            console.log(err)
        }
    }

    useEffect(() => {
        if(usuario != null) actualizarAtributosFichaTecList();
    },[usuario])

    return(
        <atributosFichaTecContext.Provider
            value={{
                atributosList: state.atributosList,
                actualizarAtributosFichaTecList,
                agregarAtributoFichaTec,
                modificarAtributoFichaTec,
                eliminarAtributoFichaTec,
            }}
        >
            {props.children}
        </atributosFichaTecContext.Provider>
    )

}

export default AtributosFichaTecState;